export default {
  account: {
    path: '/account',
    isShown: true,
  },
  project: {
    path: '/project',
    isShown: true,
    isShownAIChatbot: false,
    isProofreadButton: true,
    subRoutes: {
      'questionnaire-answers': {
        isShown: true,
      },
      outline: {
        isShown: true,
      },
      chapters: {
        isShown: true,
      },
      'style-samples': {
        isShown: false,
      },
      'book-sample': {
        path: '/book-sample',
        isShown: true,
      },
      'final-proof': {
        isShown: true,
      },
    },
  },
  'project-overview': {
    path: '/project-overview',
    isShown: true,
  },
  'my-projects': {
    path: '/my-projects',
    isShown: true,
  },
};
